<div class="h-full rounded-lg border bg-white p-4 shadow dark:border-gray-700 dark:bg-gray-900">
  <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
    {{ 'dashboard.charts.cleaningSchedules.title' | translate }}
  </h3>

  @if (isLoading()) {
    <div class="flex h-48 flex-col items-center justify-center space-y-2">
      <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
      <span class="text-sm text-gray-500">{{ 'common.loading' | translate }}</span>
    </div>
  } @else if (error()) {
    <div class="flex h-48 items-center justify-center">
      <p class="text-red-600">{{ error() }}</p>
    </div>
  } @else {
    <p-chart
      type="line"
      [data]="chartData()"
      [options]="chartOptions()"
      class="w-full"
    >
    </p-chart>
  }
</div>
